import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, TextField } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';

interface NewUnitDialogProps {
  loading: boolean;
  onClose: () => void;
  onSubmit: (unitName: string) => void;
}

interface FormFields {
  name: string;
}

export function NewUnitDialog(props: NewUnitDialogProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormFields>();

  const onSubmit = (data: FormFields) => {
    props.onSubmit(data.name);
  };

  return (
    <Dialog open onClose={props.onClose} fullWidth maxWidth="xs">
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Nová nehnuteľnosť</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            required
            error={!!errors.name}
            helperText={errors.name?.message}
            label="Názov"
            {...register('name', { required: 'Názov je povinný' })}
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose}>Zrušiť</Button>
          <Button type="submit" variant="contained">
            Pridať
          </Button>
        </DialogActions>
        {props.loading && <LinearProgress />}
      </form>
    </Dialog>
  );
}
